(function() {
  'use strict';

  angular
    .module('linshare.quota', []);

})();

require('./constants');
require('./services/quotaService');